export const fallbackLanguage = 'en';
export const languages = ['en'];
export const defaultNamespace = 'common';
export const preloadNamespaces = ['common', 'auth', 'devices', 'weather', 'geo'];
